import React, { useEffect } from "react";
import Navmenu from "../components/navmenu";
import "../scss/style.scss";
import useDarkMode from "use-dark-mode";
import Toggle from "../components/toggle";
const LayoutPage = ({ children }) => {
  const darkMode = useDarkMode(false);

  return (
    <>
      <Navmenu></Navmenu>
      <div>
        <main>
          {" "}
          <Toggle checked={darkMode.value} onChange={darkMode.toggle} />
          {children}
        </main>
        <footer>
          <div></div>
        </footer>
      </div>
    </>
  );
};

export default LayoutPage;
